import { Lock } from 'lucide-react'
import { useState, type FormEvent } from 'react'

import { Button, Field } from '../../ui'

interface Props {
  onSubmit: (password: string) => void
  error: string | null
  busy: boolean
}

/**
 * Pantalla de contraseña del portal.
 *
 * El cliente final llega aquí desde un enlace de WhatsApp, casi siempre en el
 * móvil y sin contexto: no sabe qué es «ChasquiTambo» ni le importa. El texto habla de
 * su galería, no del producto.
 *
 * Nota de marca blanca: aquí todavía NO se conoce el estudio —el branding llega
 * con la sesión, que es justo lo que esta pantalla está pidiendo—, así que se
 * pinta con el tema por defecto. Es el único sitio del portal donde el cliente
 * no ve los colores de su fotógrafo, y no hay forma de evitarlo sin revelar de
 * quién es un enlace protegido a cualquiera que lo pruebe.
 */
export function UnlockScreen({ onSubmit, error, busy }: Props) {
  const [password, setPassword] = useState('')

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    if (password.trim() !== '') onSubmit(password)
  }

  return (
    <div className="grid min-h-dvh place-items-center px-6 pb-safe pt-safe">
      <form onSubmit={handleSubmit} className="w-full max-w-form">
        <div className="flex flex-col items-center text-center">
          <span className="grid h-12 w-12 place-items-center rounded-full bg-surface-sunken text-ink-subtle">
            <Lock size={20} strokeWidth={1.75} aria-hidden />
          </span>

          <h1 className="mt-4 text-heading font-semibold text-ink">Esta galería está protegida</h1>
          <p className="mt-2 text-body text-ink-muted">
            Escribe la contraseña que te enviaron para ver tus fotos.
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-4">
          {/* `Field` ata solo el htmlFor y el aria-describedby del error, que
              antes había que acordarse de escribir en cada formulario. */}
          <Field
            label="Contraseña"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            autoFocus
            autoComplete="off"
            error={error}
          />

          <Button type="submit" size="lg" block busy={busy && 'Abriendo…'}>
            Ver galería
          </Button>
        </div>
      </form>
    </div>
  )
}
